import React, { createContext, useContext, useEffect, useState } from "react";
import api_users from "../services/api";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authState, setAuthState] = useState({
    user: null,
    role: null,
    loading: true,
  });

  // Φόρτωση χρήστη στην αρχή
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await api_users.users.getCurrentUser();
        setAuthState({
          user: res.data.user,
          role: res.data.role,
          loading: false,
        });
      } catch (err) {
        setAuthState({
          user: null,
          role: null,
          loading: false,
        });
      }
    };

    fetchUser();
  }, []);

  const login = async (email, password) => {
    try {
      const response = await api_users.users.login(email, password);
      const { user, role } = response.data;
      setAuthState({ user, role, loading: false });
      return { success: true, data: response.data };
    } catch (err) {
      return {
        success: false,
        message: err.response?.data?.error || err.message,
      };
    }
  };

  const loginWithGoogle = async (googleToken) => {
    try {
      const response = await api_users.users.googleLogin({ token: googleToken });
      const { user, role } = response.data;
      setAuthState({ user, role, loading: false });
      return { success: true, data: response.data };
    } catch (err) {
      return {
        success: false,
        message: err.response?.data?.error || err.message,
      };
    }
  };

  const register = async (username, email, password) => {
    try {
      const response = await api_users.users.register(username, email, password);
      return { success: true, data: response.data };
    } catch (err) {
      return {
        success: false,
        message: err.response?.data?.error || err.message,
      };
    }
  };

const logout = async () => {
  try {
    await api_users.users.logout(); // ✅ call backend /logout to clear session cookie
  } catch (e) {
    // και να αποτύχει, εμείς καθαρίζουμε state
  }

  localStorage.removeItem("auth_token");
  localStorage.removeItem("incooking_onboarding_shown");
  localStorage.removeItem("incooking_beta_banner_closed");

  setAuthState({ user: null, role: null, loading: false });
};

  return (
    <AuthContext.Provider value={{ ...authState, login, loginWithGoogle, logout, register }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
